import { authorizationGuard } from '@/router/guards/AuthGuard';
import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router';
import { routes } from './routes';

function initializeRouter({ hostRouter }) {
  const router = createRouter({
    history: hostRouter?.mode === 'hash' ? createWebHashHistory(hostRouter?.base ?? '') : createWebHistory(),
    scrollBehavior: () => ({ y: 0 }),
    routes,
  });

  if (hostRouter && hostRouter?.beforeHooks?.length > 0) {
    hostRouter.beforeHooks.forEach((guardFn) => router.beforeEach(guardFn));
  } else {
    router.beforeEach(authorizationGuard);
  }

  return router;
}

export default initializeRouter;
